const productDetailsRegEx = /-wid-([A-Za-z0-9]*)$/i;

function getProductWidFromUrl(url: string): string | null {
    const match = url.match(productDetailsRegEx);
    if (match === null || match.length !== 2) return null;
    const productId = match[1];
    return productId;
}

function matchingRegEx(): RegExp {
    return productDetailsRegEx;
}

export default {
    getProductWidFromUrl,
    matchingRegEx
};
